module.exports = __webpack_public_path__ + "img/order2.6f6452f6.png";